import { useEffect } from "react";
import { Label } from "reactstrap";

const Index = ({ title, id }) => {
  useEffect(() => {
    // Initialize CKEditor
    if (window.CKEDITOR) {
      window.CKEDITOR.replace(`${id}`);
    }
  }, []);
  return (
    <div className="form-group my-2">
      <Label className="form-label" htmlFor={id}>
        {title}
      </Label>

      <div className="form-control-wrap">
        <textarea id={`${id}`} name={`${id}`}></textarea>
      </div>
    </div>
  );
};

export default Index;
